<script>
export default {
  props: ['value']
}
</script>

<template>
  <div class="go1-flex go1-hotel-stars">
    <div v-for="index in parseInt(value)" :key="index"><i class="fas fa-star"></i></div>
    <div v-if="value%1"><i class="fas fa-star-half"></i></div>
  </div>
</template>